export const ENDPOINTS = {
    getAllSubscriptionCounts: "/bissubscription/getAllSubscriptionCounts",
    addPart2Subscriptions: "/bissubscription/subscriptions",
    ActiveSubscriptions: "/bissubscription/active",
    exceptionSubscriptions: "/bissubscription/exceptions",
    expireSubscriptions: "/bissubscription/expired",
    modifiedSubscriptions: "/bissubscription/modified/subscription",
    clearException: "/bissubscription/clearExceptions",
    getAutoPopulateData: "/inds/masterdata",
    getSearchResult: "/bissubscription/getSearchResult",
    globalSubscriptionSearch: "/bissubscription/globalSubscriptionSearch",
    getProductDetails: "/bissubscription/getProductDetails",
    auditDetails: "/bissubscription/auditDetails",
    addException: "/bissubscription/addException",
    updateTailExtensionAttributes: "/bissubscription/updateTailExtensionAttributes",
    exceptionDetails: "/bissubscription/exceptions/details",
    assignToUser: "/assignSubscription/assignToUser",
    getPart1Subscription: "/bissubscription/getPart1Subscription",
    getRecommendedProducts: "/bissubscription/getRecommendedProducts",
    saveSubscription: "/bissubscription/saveSubscription",
    draftsubscription: "/bissubscription/draftsubscription"
};